"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileEdit = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var translation_1 = __importDefault(require("@services/translation"));
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var jquery_helper_const_1 = require("@src/const/dom-crud/jquery-helper.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var profile_edit_const_1 = require("./profile-edit.const");
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var backend_services_1 = require("@src/services/backend-services");
var ProfileEdit = /** @class */ (function () {
    function ProfileEdit() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.cameraWrapper = (0, cash_dom_1.default)('#webcam-essentials');
        this.photoTaken = false;
    }
    ProfileEdit.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.config.get.environment === 'dev') {
                    this.checkFields();
                }
                (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.takePhotoButton.id).css('display', 'none');
                this.cameraWrapper.append((0, cash_dom_1.default)('<div class="webcam-container-script" style="display:flex;"><video id="camera-stream" style="width:50%;display: none;"></video><canvas id="camera-canvas" style="width:50%;display: none;"></canvas></div>'));
                this.cameraStreamVideoContainer = document.getElementById('camera-stream');
                this.cameraCanvas = document.getElementById('camera-canvas');
                this.cameraWrapper.css('display', 'none');
                this.addFormEvents();
                return [2 /*return*/];
            });
        });
    };
    ProfileEdit.prototype.addFormEvents = function () {
        var _this = this;
        (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.profileUpdateSubmit.id).on('click', function (event) {
            console.log(event);
            event.preventDefault();
            event.stopPropagation();
            _this.saveProfileChanges();
        });
        (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.openWebcamButton.id).on('click', function () {
            _this.openWebcam();
        });
        (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.takePhotoButton.id).on('click', function () {
            _this.takePhoto();
        });
        //remove webflow event handler for upload area and use our own
        (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.profileUpload.id).off('change');
        (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.profileUpload.id).on('change', function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        });
    };
    ProfileEdit.prototype.takePhoto = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stream, videoElement_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stream = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ video: true })];
                    case 2:
                        stream = _a.sent();
                        videoElement_1 = document.createElement('video');
                        videoElement_1.srcObject = stream;
                        videoElement_1.autoplay = true;
                        videoElement_1.onloadedmetadata = function () {
                            _this.cameraCanvas.width = videoElement_1.videoWidth;
                            _this.cameraCanvas.height = videoElement_1.videoHeight;
                            var context = _this.cameraCanvas.getContext('2d');
                            context.drawImage(videoElement_1, 0, 0, _this.cameraCanvas.width, _this.cameraCanvas.height);
                            stream.getTracks().forEach(function (track) { return track.stop(); });
                            videoElement_1.style.display = 'none';
                            _this.cameraCanvas.style.display = 'block';
                            _this.photoTaken = true;
                        };
                        (0, generator_const_1._HideErrorMessage)();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        (0, generator_const_1._ShowErrorMessage)(error_1, profile_edit_const_1._ProfileEditMapping.errorMessage.id);
                        console.error('Error accessing the camera:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProfileEdit.prototype.openWebcam = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stream, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.cameraWrapper.css('display', 'block');
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ video: true })];
                    case 1:
                        stream = _a.sent();
                        this.cameraStreamVideoContainer.srcObject = stream;
                        this.cameraStreamVideoContainer.autoplay = true;
                        this.cameraStreamVideoContainer.style.display = 'flex';
                        (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.takePhotoButton.id).css('display', 'inline-block');
                        (0, generator_const_1._HideErrorMessage)();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        (0, generator_const_1._ShowErrorMessage)(error_2, profile_edit_const_1._ProfileEditMapping.errorMessage.id);
                        console.error('Error accessing the camera:', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileEdit.prototype.saveProfileChanges = function () {
        var _this = this;
        var file_data = (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.profileUpload.id).prop('files')[0];
        var fd = new FormData();
        this.cameraCanvas.style.display = 'none';
        this.cameraStreamVideoContainer.style.display = 'none';
        var spinner = (0, generator_const_1._GetComponentLoadingSpinner)();
        if ((0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.loadingScreen.id).length) {
            (0, cash_dom_1.default)('#' + profile_edit_const_1._ProfileEditMapping.loadingScreen.id).append(spinner);
        }
        else {
            (0, jquery_helper_const_1._IsVisible)((0, cash_dom_1.default)('form')).append(spinner);
        }
        var sendRequest = function () {
            fd.append('data', JSON.stringify({
                data: {
                    customerId: localStorage.getItem('customerId'),
                    auth: localStorage.getItem('customerId') +
                        ',' +
                        localStorage.getItem('customerName') +
                        ',' +
                        localStorage.getItem('birthday'),
                    tenantKey: _this.config.get.tenantKey,
                    method: 'changeImage',
                },
            }));
            (0, backend_services_1.betterFetch)('https://files.fittec.io/files/webflow/new-magicline/dev-php/magicline-api.php', {
                method: 'POST',
                body: fd,
            })
                .then(function (response) { return response.json(); })
                .then(function () {
                (0, error_helper_const_1._ShowSuccessMessage)(translation_1.default.t('uploadSuccessful'), profile_edit_const_1._ProfileEditMapping.successMessage.id);
                (0, generator_const_1._HideErrorMessage)();
                (0, generator_const_1._DeleteLoadingScreen)();
            })
                .catch(function (error) {
                var _a;
                console.log('REQUEST ERROR', error);
                var errorJSON;
                try {
                    errorJSON = JSON.parse(error.message);
                }
                catch (_b) {
                    errorJSON = {};
                }
                (0, generator_const_1._ShowErrorMessage)((_a = errorJSON === null || errorJSON === void 0 ? void 0 : errorJSON.error) !== null && _a !== void 0 ? _a : error, profile_edit_const_1._ProfileEditMapping.errorMessage.id);
                (0, generator_const_1._HideErrorMessage)();
                (0, generator_const_1._DeleteLoadingScreen)();
            });
        };
        if (this.photoTaken === true) {
            this.cameraCanvas.toBlob(function (blob) {
                fd.append('file', blob, 'canvas-image.jpg');
                sendRequest();
            });
        }
        else {
            fd.append('file', file_data);
            sendRequest();
        }
    };
    ProfileEdit.prototype.checkFields = function () {
        Object.values(profile_edit_const_1._ProfileEditMapping).forEach(function (field) {
            if ((0, cash_dom_1.default)('#' + field.id).length === 0) {
                console.info('You can provide this custom field by using id=' + field.id);
            }
        });
    };
    return ProfileEdit;
}());
exports.ProfileEdit = ProfileEdit;
